import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import {
  HospitalLogDetail,
  HospitalView,
  HospitalVisitorOrderSummariesView,
  HospitalVisitorOrderView,
  SatisfactionStatistics,
  TreatmentReviewStatistics,
} from '../../contracts/hospital'
import { SolarResponse } from '../../foundation'

export class HospitalReader {
  constructor(private axios: AxiosInstance) {}

  async getHospital(hospitalId: number): Promise<HospitalView> {
    const { data } = await this.axios.request<HospitalView>({
      url: '/hospital/user/queries/get-hospital/process',
      method: 'post',
      data: {
        hospitalId,
      },
    })

    return data
  }

  async getHospitalShareLink(hospitalId: number) {
    const { data } = await this.axios.request<SolarResponse<{ shareLink: string }>>({
      url: `/hospital/${hospitalId}/share-links`,
      method: 'post',
    })

    return data
  }

  async getHospitalLogDetail(hospitalId: number): Promise<HospitalLogDetail> {
    const config: AxiosRequestConfig = {
      url: '/hospital/log/query/get-hospital/process',
      method: 'post',
      data: { hospitalId },
    }
    const { data } = await this.axios.request<HospitalLogDetail>(config)
    return data
  }

  async getVisitorOrder(hospitalId: number): Promise<AxiosResponse<HospitalVisitorOrderView>> {
    const config: AxiosRequestConfig = {
      url: '/hospital/user/queries/visitor-order/process',
      method: 'get',
      params: { hospitalId },
    }

    const response = await this.axios.request<HospitalVisitorOrderView>(config)

    return response
  }

  async getVisitOrderSummaries(hospitalId: number): Promise<AxiosResponse<HospitalVisitorOrderSummariesView>> {
    const config: AxiosRequestConfig = {
      url: '/hospital/user/queries/visit-order-summaries/process',
      method: 'get',
      params: { hospitalId },
    }

    const response = await this.axios.request<HospitalVisitorOrderSummariesView>(config)

    return response
  }

  async postVisitorOrderTracking(hospitalId: number, liveActivityDeviceToken?: string): Promise<void> {
    await this.axios.request({
      url: '/hospital/user/queries/visitor-order-tracking/execute',
      method: 'post',
      data: {
        hospitalId,
        ...(liveActivityDeviceToken && { liveActivityDeviceToken }),
      },
    })
  }

  async getTreatmentReviewStatistics(hospitalId: number): Promise<TreatmentReviewStatistics> {
    const { data } = await this.axios.request<TreatmentReviewStatistics>({
      url: '/hospital/user/queries/treatment-rating-statistics/process',
      method: 'post',
      data: {
        hospitalId,
      },
    })

    return data
  }

  async getSatisfactionStatistics(hospitalId: number): Promise<SatisfactionStatistics> {
    const { data } = await this.axios.request<SatisfactionStatistics>({
      url: '/hospital/user/queries/satisfaction-statistics/process',
      method: 'post',
      data: {
        hospitalId,
      },
    })

    return data
  }
}
